import styled from "styled-components";

export const LabelRadio = styled('label')`
  ${({ theme }) => `
    font-size: ${theme.fontSize.px16};
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    position: relative;
    cursor: pointer;
    line-height: 1;
    &::before {
        content: '';
        position: absolute;
        border: 2px solid #ffffff;
        width: 10px;
        height: 10px;
        border-radius: 100%;
        left: 2px;
        top: 2px;
    }
`}`

export const InputRadio = styled('input')`
  ${({ theme }) => `
    margin: ${theme.spacing.none} ${theme.spacing.px10} ${theme.spacing.none} ${theme.spacing.none};
    width: 18px;
    height: 18px;
    appearance: none;
    border: 2px solid ${theme.colors.blue2};
    border-radius: ${theme.rounded.full};
    outline: none;
    &:checked {
        background: ${theme.colors.blue2};
    }
  `}`;